import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { HelmetProvider } from 'react-helmet-async';
import router from '@/router/Router';
import '@/assets/scss/styles.scss';
import Head from '@/components/Head';
import { StartPopupProvider } from '@/hooks/useStartPopup';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<HelmetProvider>
		<StartPopupProvider>
			<Head />
			<RouterProvider router={router} />
		</StartPopupProvider>
	</HelmetProvider>
);
